import React from 'react';

import IconAlaricBg from '../../assets/img/alaricbg_logo.svg';
import PortalLogo from '../../assets/img/portal_logo_carousel.svg';

type Props = {
  className?: string;
  alaricBgLogo?: boolean;
  isLayout?: boolean;
};

const HeaderLogo = ({ className, alaricBgLogo, isLayout }: Props) => {
  const handleLogo = () => (alaricBgLogo ? IconAlaricBg : PortalLogo);

  return (
    <img
      src={handleLogo()}
      alt="logo"
      id="10nLogo"
      aria-label="10n logo"
      className={className}
    />
  );
};

export default HeaderLogo;
